import { Branding, DisabledPrompt, ModalOpen, useStateManager } from "@bcm-dev/bcms-vite";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
import "./mobile.css";


/**
 * @function ChatNavigationWidget
 * @return {React.Component}
 * @exported true
 * @description This is specific navigation component for the ChatPage.
 */
export default function ChatNavigationWidget(props) {
  const { onEndSession } = useStateManager();

  return(
    <div className="flex-height navigation-container flex-container flex-horizontal align-center justify-center">
      <div className="set-width spacer">
        {/* empty for spacing */}
      </div>
      
      <div className="flex-width text-center flex-container align-center flex-horizontal justify-center left-icon-container">
        <Branding id="additional_chat_functionality_abi22" value="true" default="true">
          <DisabledPrompt>
            <div className="chat-nav-item send-item">
              <div className="chat-nav-circle flex-container flex-horizontal align-center" data-point="Chat_Send">
                <SVGAsset id="PaperclipIcon" className="chat-nav-icon" />
              </div>
              <span>Send</span>
            </div>
          </DisabledPrompt>
          <DisabledPrompt>
            <div className="chat-nav-item voice-item">
              <div className="chat-nav-circle flex-container flex-horizontal align-center" data-point="Chat_Voice">
                <SVGAsset id="PhoneIcon" className="chat-nav-icon" />
              </div>
              <span>Voice</span>
            </div>
          </DisabledPrompt>
          <DisabledPrompt>
            <div className="chat-nav-item mute-item">
              <div className="chat-nav-circle flex-container flex-horizontal align-center" data-point="Chat_Mute">
                <SVGAsset id="MuteIcon" />
              </div>
              <span>Mute</span>
            </div>
          </DisabledPrompt>
          <DisabledPrompt>
            <div className="chat-nav-item video-item">
              <div className="chat-nav-circle flex-container flex-horizontal align-center" data-point="Chat_Video">
                <SVGAsset id="VideoCameraIcon" className="chat-nav-icon" />
              </div>
              <span>Video</span>
            </div>
          </DisabledPrompt>
          <DisabledPrompt>
            <div className="chat-nav-item share-item">
              <div className="chat-nav-circle flex-container flex-horizontal align-center" data-point="Chat_Share">
                <SVGAsset id="MonitorIcon" className="chat-nav-icon" />
              </div>
              <span>Share</span>
            </div>
          </DisabledPrompt>
          <DisabledPrompt>
            <div className="chat-nav-item settings-item">
              <div className="chat-nav-circle flex-container flex-horizontal align-center" data-point="Chat_Settings">
                <SVGAsset id="GearOutlineIcon" className="chat-nav-icon" />
              </div>
              <span>Settings</span>
            </div>
          </DisabledPrompt>
          <DisabledPrompt>
            <div className="chat-nav-item keypad-item">
              <div className="chat-nav-circle flex-container flex-horizontal align-center" data-point="Chat_Keypad">
                <SVGAsset id="KeypadButtonsIcon" />
              </div>
              <span>Keypad</span>
            </div>
          </DisabledPrompt>
        </Branding>
      </div>
      

      <div className="set-width flex-container justify-right right-icon-container">
        <ModalOpen id="ChatEndSessionModal" data={{ "onClick" : onEndSession }}>
          <div className="chat-nav-item text-center exit-item">
            <div className="chat-nav-circle flex-container flex-horizontal align-center">
              <SVGAsset id="OpenDoorIcon" />
            </div>
            <span data-point="Chat_Exit">Exit</span>
          </div>
        </ModalOpen>
      </div>
    </div>
  );
}